import { formatPhoneNumber } from '@clearverify/utils';

import { PeoInfoFragment } from 'src/api';
import { ClickableLabel, UserStatusChip } from 'src/components/common';
import { DemoPrivacyText } from 'src/components/demoPrivacyMode';
import { TableColumn } from 'src/components/table';
import { buildPeoDetailsUrl, getPeoStatus } from 'src/utils/peo';

const PEOS_TABLE_DISPLAY_NAME_COLUMN: TableColumn<PeoInfoFragment> = {
  title: 'Company Name',
  key: 'displayName',
  sortable: true,
  render: (_valueByDataPath, peo) => {
    return (
      <ClickableLabel
        type="link"
        to={buildPeoDetailsUrl(peo.id)}
        label={peo.displayName}
        logoUrl={peo.logo?.downloadUrl}
      />
    );
  },
};
const PEOS_TABLE_DISPLAY_NAME_COLUMN_WITHOUT_AVATAR: TableColumn<PeoInfoFragment> = {
  title: 'Company Name',
  key: 'displayName',
  sortable: true,
  render: (_valueByDataPath, peo) => {
    return (
      <ClickableLabel
        type="link"
        to={buildPeoDetailsUrl(peo.id)}
        label={peo.displayName}
        withoutLogo
      />
    );
  },
};

const PEOS_TABLE_PEO_PP_DISPLAY_NAME_COLUMN: TableColumn<PeoInfoFragment> = {
  title: 'PEO Payroll Provider',
  key: 'peoPayrollProvider.displayName',
  sortable: true,
  render: (_valueByDataPath, peo) => {
    return <DemoPrivacyText>{peo.peoPayrollProvider?.displayName || '–'}</DemoPrivacyText>;
  },
};

const PEOS_TABLE_CONTACT_EMAIL_COLUMN: TableColumn<PeoInfoFragment> = {
  title: 'Contact Email',
  key: 'contactEmail',
  sortable: true,
  render: (_valueByDataPath, peo) => {
    return <DemoPrivacyText>{peo.contactEmail}</DemoPrivacyText>;
  },
};

const PEOS_TABLE_CONTACT_PHONE_COLUMN: TableColumn<PeoInfoFragment> = {
  title: 'Contact Phone',
  key: 'contactPhoneNumber',
  render: (_valueByDataPath, peo) => {
    return <DemoPrivacyText>{formatPhoneNumber(peo.contactPhoneNumber)}</DemoPrivacyText>;
  },
};

const PEOS_TABLE_STATUS_COLUMN: TableColumn<PeoInfoFragment> = {
  title: 'Status',
  key: 'status',
  render: (_valueByDataPath, peo) => {
    return <UserStatusChip userStatus={getPeoStatus(peo)} />;
  },
};

export const PEOS_TABLE_COLUMNS: Array<TableColumn<PeoInfoFragment>> = [
  PEOS_TABLE_DISPLAY_NAME_COLUMN,
  PEOS_TABLE_CONTACT_EMAIL_COLUMN,
  PEOS_TABLE_CONTACT_PHONE_COLUMN,
  PEOS_TABLE_STATUS_COLUMN,
];

export const PEOS_TABLE_COLUMNS_WITHOUT_AVATAR: Array<TableColumn<PeoInfoFragment>> = [
  PEOS_TABLE_DISPLAY_NAME_COLUMN_WITHOUT_AVATAR,
  PEOS_TABLE_CONTACT_EMAIL_COLUMN,
  PEOS_TABLE_CONTACT_PHONE_COLUMN,
  PEOS_TABLE_STATUS_COLUMN,
];

export const PEOS_TABLE_CV_COLUMNS: Array<TableColumn<PeoInfoFragment>> = [
  PEOS_TABLE_DISPLAY_NAME_COLUMN,
  PEOS_TABLE_PEO_PP_DISPLAY_NAME_COLUMN,
  PEOS_TABLE_CONTACT_EMAIL_COLUMN,
  PEOS_TABLE_CONTACT_PHONE_COLUMN,
  PEOS_TABLE_STATUS_COLUMN,
];

export const PEOS_TABLE_CV_COLUMNS_WITHOUT_AVATAR: Array<TableColumn<PeoInfoFragment>> = [
  PEOS_TABLE_DISPLAY_NAME_COLUMN_WITHOUT_AVATAR,
  PEOS_TABLE_PEO_PP_DISPLAY_NAME_COLUMN,
  PEOS_TABLE_CONTACT_EMAIL_COLUMN,
  PEOS_TABLE_CONTACT_PHONE_COLUMN,
  PEOS_TABLE_STATUS_COLUMN,
];
